import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import {
  getDeployment,
  getDeployments,
  getDeploymentsWithRoles,
  getPaginatedDeployments,
} from "@/api/resources/deployments/api";
import i18n from "@/providers/i18n";
import { type QueryPaginationFilters } from "@/utils/pagination";

const entity = i18n.t("deployment");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("deployments");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const deploymentsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "deployments"],
  lists: () => [...deploymentsQueryKeys.all(), "list"],
  listAll: () => [...deploymentsQueryKeys.lists(), "all"],
  listWithRoles: () => [...deploymentsQueryKeys.lists(), "withRoles"],
  listPaginated: (queryKeyPaginationFilters: QueryPaginationFilters) => [
    ...deploymentsQueryKeys.lists(),
    "paginated",
    queryKeyPaginationFilters,
  ],
  byId: (id?: string) => [...deploymentsQueryKeys.all(), "byId", id],
};

export const deploymentsQueries = {
  listAll: () =>
    queryOptions({
      queryKey: [...deploymentsQueryKeys.listAll()],
      queryFn: () => getDeployments(),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listWithRoles: () =>
    queryOptions({
      queryKey: [...deploymentsQueryKeys.listWithRoles()],
      queryFn: () => getDeploymentsWithRoles(),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listPaginated: (queryKeyPaginationFilters: QueryPaginationFilters) =>
    queryOptions({
      queryKey: [...deploymentsQueryKeys.listPaginated(queryKeyPaginationFilters)],
      queryFn: () => getPaginatedDeployments(queryKeyPaginationFilters),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...deploymentsQueryKeys.byId(id)],
      queryFn: id ? () => getDeployment({ id }) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
